<template>
    <div class="match-change">
        <div class="match-change__slots">
            <div class="match-change__slot">
                <div class="font-weight-bold">{{ slotTeams(request.match1) }}</div>
                <div class="text-caption grey--text text--darken-1">
                    {{ formatMatchDate(request.match1.matchDatetime) }}<span v-if="request.match1.arenaName"> · {{ request.match1.arenaName }}</span>
                </div>
            </div>
            <v-icon small color="primary darken-1" class="match-change__swap" title="The slots are swapped">mdi-swap-vertical</v-icon>
            <div class="match-change__slot">
                <div class="font-weight-bold">{{ slotTeams(request.match2) }}</div>
                <div class="text-caption grey--text text--darken-1">
                    {{ formatMatchDate(request.match2.matchDatetime) }}<span v-if="request.match2.arenaName"> · {{ request.match2.arenaName }}</span>
                </div>
            </div>
        </div>
        <div class="text-body-2 mt-1">
            Requested by <b>{{ request.requesterTeamName }}</b>
            <span v-if="request.requesterPlayerName">(captain {{ request.requesterPlayerName }})</span>
            · {{ formatAgo(request.createdAt) }}
        </div>
        <div v-if="request.reason" class="text-body-2 mt-1 grey--text text--darken-2">"{{ request.reason }}"</div>
        <div class="match-change__votes mt-1">
            <v-chip
                v-for="vote in request.votes"
                :key="vote.team.id"
                x-small
                outlined
                :color="voteColor(vote)"
                :title="vote.playerName ? `Voted by ${vote.playerName}` : ''"
            >
                {{ vote.team.name }}: {{ voteLabel(vote) }}
            </v-chip>
        </div>
    </div>
</template>

<script>
    import { formatAgo, formatMatchDate, slotTeams, voteColor, voteLabel } from '@/utils/requests'

    // The two matches of a match change request, the requester and the votes of the teams
    export default {
        name: 'MatchChangeSummary',
        props: {
            request: {
                type: Object,
                required: true
            }
        },
        methods: { formatAgo, formatMatchDate, slotTeams, voteColor, voteLabel }
    }
</script>

<style scoped>
.match-change {
    white-space: normal;
}

.match-change__slots {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.match-change__swap {
    align-self: flex-start;
    margin-left: 4px;
}

.match-change__votes {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}
</style>
